<template>
   <div class="slider" :class="{ onDark: onDark }">
      <!-- Cards -->
      <header>
         <h4 class="bold" v-if="headline">{{ headline }}</h4>
         <p class="small" v-if="description">{{ description }}</p>
         <SliderActions
            v-if="cards.length > 3"
            :progress="sliderProgress"
            @previous="slider.prev()"
            @next="slider.next()"
         />
      </header>
      <!-- <template v-if="cards"> -->
      <!-- <Swiper ref="swiper" @progress="handleProgress"> -->

      <div class="slider-static" :class="[card]" v-if="cards.length <= 3">
         <component
            v-for="(sliderCard, index) in cards"
            :key="index"
            class="keen-slider__slide"
            :is="componentMap[card]"
            :card="sliderCard"
         />
      </div>
      <div
         ref="container"
         :class="{ notInited: !mounted }"
         class="keen-slider"
         v-else
      >
         <component
            v-for="(sliderCard, index) in cards"
            :key="index"
            class="keen-slider__slide"
            :is="componentMap[card]"
            :card="sliderCard"
         />
      </div>
      <!-- </template> -->
      <!-- Loading State -->
      <!-- <LoadingCards v-else :size="card == 'smallCard' ? 'small' : 'large'" /> -->
   </div>
</template>
<script setup lang="ts">
import { useKeenSlider } from "keen-slider/vue.es";
const mounted = ref(false);
const componentMap = {
   smallCard: resolveComponent("SmallCard"),
   largeCard: resolveComponent("LargeCard"),
   imageCard: resolveComponent("ImageCard"),
};
const sliderProgress = ref(0);
const props = defineProps({
   headline: { type: String, default: null, required: true },
   link: { type: String, default: null },
   description: { type: String, default: null },
   cards: { type: Array, required: true, default: [] },
   card: {
      type: String,
      required: true,
      validator(value, props) {
         return ["smallCard", "imageCard", "largeCard"].includes(value);
      },
   },
   onDark: { type: Boolean, default: false },
});
const handleProgress = (s) => {
   sliderProgress.value = s.track.details.rel / s.track.details.maxIdx;
};

const [container, slider] = useKeenSlider({
   mode: "snap",
   slides: { perView: "auto", spacing: 32 },
   // window?.innerWidth * 0.025
   slideChanged: handleProgress,
   created: (s) => {
      mounted.value = true;
   },
});
onMounted(() => {});
</script>

<style lang="scss" scoped>
@import url("keen-slider/keen-slider.css");
@import "~/assets/scss/globals/card-slider";
</style>
